import React from 'react';
import Footer from './components/Footer';
import { useMapVisibility } from './hooks/useMapVisibility';
import './HomePage.css';

const HomePage = () => {
  const { mapEnabled, loading } = useMapVisibility();

  return (
    <div className="container-fluid home">
      <div className="row">
        <div className="col-12 section-1">
          <div className="content">
            <div className='apyce-logo'>
              <img src="/images/site/apyce-logo.png" alt="Logo" />
            </div>
            {/* Desktop */}
            <div className='home-logo mx-auto d-none d-md-block mb-3'>
              <img src="/images/site/home-logo.png" alt="Logo" />
            </div>
            {/* Mobile */}
            <div className='home-logo mobile mb-3 mx-auto d-block d-md-none'>
              <img src="/images/site/home-logo-mobile.png" alt="Logo" />
            </div>
            {
              <>
                {!loading && mapEnabled && (
                  <div className='home-button-container mx-auto'>
                    <a href="/locales" type="button" className='btn btn-home-primary map btn-home-primary px-2 py-4 text-uppercase'>
                      <strong>Consultá los locales adheridos</strong>
                    </a>
                  </div>
                )}
              </>
            }
            <br />

            <div className='home-button-container mt-1 mx-auto'>
              {!loading && !mapEnabled && (
                <a href="/register" type="button" className='btn btn-home-primary px-2 py-4 text-uppercase '><strong>Registrá tu local acá</strong></a>
              )}
            </div>

            <div className='home-link-container mx-auto mt-4 mb-2'>
              {!loading && !mapEnabled && (
                <a href="/login">Si ya estás registrado ingresá acá</a>
              )}
            </div>
            {/* Desktop */}
            {/*
            <div className='home-text-container mx-auto mt-5 d-none d-md-block'>              
              <p className="text-1">No te pierdas esta oportunidad única en el año<br/>para disfrutar tus pizzas favoritas con <strong>50% de descuento</strong> y las empanadas <strong>3x2</strong>.<br />Invita a tus amigos, junta la famila y vení a celebrar el amor por la pizza"</p>
              
              <p className="text-2 mb-5">&#161;Es una fiesta imperdible&#33;</p>
            </div>
            */}
            {/* Mobile */}
            {/*
            <div className='home-text-container mx-auto mt-3 d-block d-md-none'>
              <p className="text-1">No te pierdas esta oportunidad única en el año para disfrutar tus pizzas favoritas con <strong>50% de descuento</strong> y las empanadas <strong>3x2</strong>. Invita a tus amigos, junta a tu familia y vení a celebrar el amor por la pizza</p>
              <p className="text-2 mb-5">&#161;Es una fiesta imperdible&#33;</p>
            </div>
            */}
            {/* Desktop */}
            {/*        
            <div className='home-text-container mx-auto mt-5 d-none d-md-block'>              
              <p className="text-1">Sumate desde cualquier parte del país y se parte del evento gastronómico del año.<br/>No te quedes afuera de este momento único, donde los locales de pizza y empanadas se llenan de gente.</p>              
              <p className="text-2 mb-5">&#161;Inscribí tu local, es gratis y muy fácil&#33;</p>
            </div>
            */}
            {/*
            <div className='home-text-container mx-auto mt-5 d-none d-md-block'>              
              <p className="text-1">Si sos fan de la pizza y la empanada, conocé en nuestro mapa interactivo los más de 1.500 locales adheridos de todo el païs.</p>              
              <p className="text-2 mb-5">&#161;Conocé los locales más cercanos a tu ubicación&#33;</p>
            </div>
            */}
            {/* Mobile */}
            {/* 
            <div className='home-text-container mx-auto mt-3 d-block d-md-none'>
            <p className="text-1">Si sos fan de la pizza y la empanada, conocé en nuestro mapa interactivo los más de 1.500 locales adheridos de todo el païs.</p>              
            <p className="text-2 mb-5">&#161;Conocé los locales más cercanos a tu ubicación&#33;</p>
            </div>
            */}
            {/*
            <div className='home-map-text text-center mt-1 mx-auto pt-3 pt-md-4'>
             <p>A partir del 12 de Septiembre se va a encontrar disponible el mapa interactivo, para que los fans de la pizza y empanadas puedan consultar locales adheridos.</p>
            </div>
            */}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12 section-2">
          {/* 
          <div className='home-button-container mb-3 mx-auto mt-md-5'>
            <button type="button" className='btn btn-home-secondary'>Reel Edición 2023</button>
          </div>
          */}
          <div className="title mx-auto mt-3 mt-md-5">
            <h2 className="text-center">Datos Edición 2025</h2>
          </div>
          <div className="last-edition-items d-flex flex-column flex-md-row mx-auto">
            <div className="last-edition-item my-2 my-md-4 text-center">
              <img className="item-image mb-2" src="/images/site/home-icon-1.png" alt="locales participantes" />
              <div className="item-number">+1.500</div>
              <div className="item-text">Comercios adheridos</div>
            </div>
            <div className="last-edition-item my-2 my-md-4 text-center">
              <img className="item-image mb-2" src="/images/site/home-icon-2.png" alt="promociones" />
              <div className="item-number">+140.000</div>
              <div className="item-text">Visitas al sitio</div>
            </div>
            <div className="last-edition-item my-2 my-md-4 text-center">
              <img className="item-image mb-2" src="/images/site/home-icon-3.png" alt="agenda" />
              <div className="item-number">X3</div>
              <div className="item-text">Ventas</div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12 section-3 pb-5">
          <div className='apyce-logo mt-5 mx-auto'>
            <img src="/images/site/apyce-logo.png" alt="Logo apyce blue" />
          </div>
          <div className="text mx-auto mt-4">
            <p className="text-center">Es el evento gastronómico más importantes del año porque la <strong>Pizza</strong> y <strong>Empanada</strong> tienen un lugar muy especial en el corazón de todos los argentinos. Queremos que este día todos puedan disfrutarlas. Seguinos y no te pierdas de nada.</p>
          </div>
          <div className="social mx-auto d-flex flex-row mt-2 mb-2">
            <div className='social-icon-container mx-2'>
              <a href="https://www.facebook.com/apyce.ar" rel="noreferrer" target='_blank'>
                <img src="/images/site/Facebook-white.png" alt="facebook" />
              </a>
            </div>
            <div className='social-icon-container mx-2'>
              <a href="https://x.com/APYCE_AR" rel="noreferrer" target='_blank'>
                <img src="/images/site/Twitter-white.png" alt="Twitter" />
              </a>
            </div>
            <div className='social-icon-container mx-2'>
              <a href="https://www.instagram.com/apyce.ar/" rel="noreferrer" target='_blank'>
                <img src="/images/site/Instagram-white.png" alt="Instagram" />
              </a>
            </div>
            <div className='social-icon-container mx-2'>
              <a href="https://www.youtube.com/@apyceArgentina" rel="noreferrer" target='_blank'>
                <img src="/images/site/Youtube-white.png" alt="Youtube" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12 section-4">
          <div className="brands mx-auto mb-5 pt-5">
            <h3 className="title text-center">Sponsors</h3>
            <div className="d-flex border-bottom flex-wrap justify-content-center mt-4 mb-2">
              <div className='brand-icon mx-5'>
                <img src="/images/site/sponsors/sponsor-10.png" alt="Milkaut" />
              </div>
              <div className='brand-icon mx-5'>
                <img src="/images/site/sponsors/sponsor-7.png" alt="DGMAQ" />
              </div>
              <div className='brand-icon mx-5'>
                <img src="/images/site/sponsors/sponsor-1.png" alt="Stagioni" />
              </div>
            </div>
            <div className="d-flex flex-wrap border-bottom justify-content-center mt-4">
              <div className='brand-icon mx-1 mx-md-3'>
                <img src="/images/site/sponsors/sponsor-11.png" alt="Molinos Canuelas" />
              </div>
              <div className='brand-icon mx-1 mx-md-3'>
                <img src="/images/site/sponsors/sponsor-5.png" alt="La canzonetta" />
              </div>
              <div className='brand-icon mx-1 mx-md-3'>
                <img src="/images/site/sponsors/sponsor-9.png" alt="Gentleman Caracas" />
              </div>
              <div className='brand-icon mx-2 mx-md-3'>
                <img src="/images/site/sponsors/sponsor-2.png" alt="Baires Cocina" />
              </div>
              <div className='brand-icon mx-1 mx-md-3'>
                <img src="/images/site/sponsors/sponsor-4.png" alt="Campo Lac" />
              </div>
              <div className='brand-icon mx-1 mx-md-3'>
                <img src="/images/site/sponsors/sponsor-15.png" alt="Campo Lac" />
              </div>
            </div>
            <div className="d-flex flex-wrap justify-content-center mt-4 mb-4">
              <div className='brand-icon mx-1 mx-md-3'>
                <img src="/images/site/sponsors/sponsor-8.png" alt="Don Fabian" />
              </div>
              <div className='brand-icon mx-1 mx-md-3'>
                <img src="/images/site/sponsors/sponsor-3.png" alt="Barraza" />
              </div>
              <div className='brand-icon mx-1 mx-md-3'>
                <img src="/images/site/sponsors/sponsor-12.png" alt="Mozzari" />
              </div>
              <div className='brand-icon mx-1 mx-md-3'>
                <img src="/images/site/sponsors/sponsor-13.png" alt="Mozzari" />
              </div>
              <div className='brand-icon mx-1 mx-md-3'>
                <img src="/images/site/sponsors/sponsor-14.png" alt="Al sur" />
              </div>
            </div>
            <div className="d-flex justify-content-center flex-wrap mt-4">
              <h4 className="partners text-left">Acompaña</h4>
              <div className='brand-icon mx-1 mx-md-3'>
                <img src="/images/site/partner/partner-1.png" alt="Don Fabian" />
              </div>
              <div className='brand-icon mx-1 mx-md-3'>
                <img src="/images/site/partner/partner-2.png" alt="Don Fabian" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <Footer />
      </div>
    </div>
  );
};

export default HomePage;
